import React from 'react';
import PropTypes from 'prop-types';
import AppDetailContentDescriptionPoints from './AppDetailContentDescriptionPoints';
import getContent from '../lib/dictionaryFetcher';

const AppDetailContentDescription = props => {
  const { partner } = props;
  const fullDescription = getContent(
      'merchanthub',
      `apps.${partner}.fullDescription`,
      ''
    ),
    titles = getContent('merchanthub', `apps.${partner}.descProps.titles`, []);

  return (
    <div className="marketplace-fulldescription">
      {titles.length > 0 && <AppDetailContentDescriptionPoints {...props} />}
      {fullDescription}
    </div>
  );
};

AppDetailContentDescription.propTypes = {
  partner: PropTypes.string,
  isDesktop: PropTypes.bool
};

export default AppDetailContentDescription;
